import React from "react";
import { useSpendingDemandSpendingList } from "../../../../hooks";
import { numberToStingWithSpaces } from "../../../../../../utils/numberDisplayer";

interface SpendingTotalRendererProps {
  spendingDemandId: string;
}

export const SpendingTotalRenderer: React.FC<SpendingTotalRendererProps> = ({ spendingDemandId }) => {
  const { totalSpending, getAllQuery } = useSpendingDemandSpendingList(spendingDemandId, {
    disableQuery: !spendingDemandId,
    pageSize: 0, // Get all spendings without pagination
  });

  if (getAllQuery.isLoading) {
    return <span style={{ color: '#999', fontSize: '0.8rem' }}>...</span>;
  }

  if (!totalSpending.totalTTC || totalSpending.totalTTC === 0) {
    return <span style={{ color: '#999' }}>-</span>;
  }

  return (
    <span>
      {numberToStingWithSpaces(totalSpending.totalTTC || 0)}
    </span>
  );
};

export default SpendingTotalRenderer;

